import { createFileRoute } from '@tanstack/react-router'
import { MouvementForm } from '@features/stock/components/MouvementForm'
import { useQuery } from '@tanstack/react-query'
import api from '@lib/utils/api'
import { queryKeys } from '@lib/api/queryKeys'
import { usePermissions } from '@lib/hooks/usePermissions'
import { requirePermission } from '@lib/permissions/guards'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'

export const Route = createFileRoute('/_app/stock/mouvements/$id/edit')({
  beforeLoad: ({ context }) => {
    requirePermission(PERMISSIONS.STOCK.MOVEMENTS.EDIT, context)
  },
  component: EditMouvementComponent,
})

function EditMouvementComponent() {
  const { id } = Route.useParams()
  const { canEdit } = usePermissions()
    
  const { data } = useQuery({
    queryKey: queryKeys.stock.movements.details(Number(id)),
    queryFn: async () => {
      const response = await api.get(`/mouvement_stocks/${id}`)
      return response.data
    },
  })

  if (!canEdit('stock.movements.edit')) {
    return <div className="p-6">Accès non autorisé</div>
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Modifier Mouvement</h1>
      {data && <MouvementForm mode="edit" initialData={data} />}
    </div>
  )
}
